import { render, staticRenderFns } from "./list-item-result.vue?vue&type=template&id=424f0f23&"
import script from "./list-item-result.vue?vue&type=script&lang=js&"
export * from "./list-item-result.vue?vue&type=script&lang=js&"
import style0 from "./list-item-result.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VHover,VIcon,VListItem})
